import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { recurseLangParam } from '@fcom/common/utils';

const denyAndRedirectToCorporateHome = (router: Router, route: ActivatedRouteSnapshot): false => {
  const lang = recurseLangParam(route);
  router.navigateByUrl(`/${lang}/corporate`, { replaceUrl: true });
  return false;
};

export { denyAndRedirectToCorporateHome };
